<template>
    <div>
        <md-card class="cardGame" id="cardGame">
            <md-card-content>
                <md-list>
                    <md-list-item v-for="game in seasonGames" :key="game.id">
                        <span class="md-list-item-text">{{game.d}}</span>
                        <md-button class="md-icon-button md-accent" @click="showGameInfo(game)">
                            <md-icon>more_horiz</md-icon>
                        </md-button>
                    </md-list-item>
                </md-list>
            </md-card-content>
            <md-card-actions>
                <md-button class="md-icon-button md-accent" @click="addGame()">
                    <md-icon>add_circle</md-icon>
                </md-button>
            </md-card-actions>
        </md-card>
        <md-dialog class="gameInfoInputDialog" :md-active.sync="showGameInfoDialog" id="gameInfoInputDialog">
            <md-dialog-title>Game Info</md-dialog-title>
            <md-dialog-content>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-50">
                        <md-datepicker v-model="gameInfoTemp.d" md-model-type="String">
                            <label>Date</label>
                        </md-datepicker>
                    </div>
                    <div class="md-layout-item md-size-50">
                        <md-switch v-model="broadcast" class="md-accent" v-if="isPremium && isNew">Broadcast (Read-only timer visible to all)</md-switch>
                        <md-switch v-model="broadcast" class="md-accent" v-if="isPremium && !isNew" disabled>Broadcast (Read-only timer visible to all)</md-switch>
                        <md-tooltip md-direction="top" v-if="isPremium && !isNew">Can only be set upon game creation.</md-tooltip>
                        <md-switch value="false" class="md-accent" v-if="!isPremium" disabled>Broadcast (Read-only timer visible to all)</md-switch>
                        <md-tooltip md-direction="top" v-if="!isPremium">Requires a Premium Account</md-tooltip>
                    </div>
                    <div class="md-layout-item md-size-95">
                        <md-field>
                            <label for="selectSeasonGameSchedule">Type</label>
                            <md-select v-model="gameInfoTemp.s" name="selectSeasonGameSchedule" id="selectSeasonGameSchedule">
                                <md-option v-for="schedule in seasonSchedules" :key="schedule.id" :value="schedule.id">{{schedule.n}}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-95">
                        <div class="md-layout">
                            <div class="md-layout-item md-size-100">
                                <span class="md-title">Players</span>
                            </div>
                            <div class="md-layout-item md-size-40">
                                <span>In Game</span>
                                <div class="md-layout">
                                    <div class="md-layout-item md-size-100"  v-for="(player, index) in gameInfoTemp.inGamePlayers" :key="player.id">
                                        <md-chip md-clickable @click="playerInGameClick(player, index)">{{player.n}}<md-icon>arrow_right</md-icon></md-chip>
                                    </div>
                                </div>
                            </div>
                            <div class="md-layout-item md-size-20 seasonGamesButtonColumn">
                              <div>
                                <md-button class="md-icon-button" @click="addAllPlayers()">
                                  <md-icon>keyboard_arrow_left</md-icon>
                                </md-button>
                                <br>
                                <md-button class="md-icon-button" @click="removeAllPlayers()">
                                  <md-icon>keyboard_arrow_right</md-icon>
                                </md-button>
                              </div>
                            </div>
                            <div class="md-layout-item md-size-40">
                                <span>Available</span>
                                <div class="md-layout">
                                    <div class="md-layout-item md-size-100" v-for="(player, index) in gameInfoTemp.availablePlayers" :key="player.id">
                                        <md-chip md-clickable @click="playerAvailableClick(player, index)"><md-icon>arrow_left</md-icon>{{player.n}}</md-chip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-accent" @click="deleteGame()">Delete</md-button>
                <md-button class="md-accent" @click="showGameInfoDialog = false">Close</md-button>
                <md-button class="md-accent" @click="updateGameInfo()">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import { DateTime } from 'luxon'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SeasonGames',
  data: function () {
    return {
      bypass: false,
      showGameInfoDialog: false,
      gameInfoTemp: {},
      broadcast: false,
      isNew: false
    }
  },
  computed: {
    ...mapState(['seasonSchedules', 'seasonPlayers', 'seasonGames', 'activeSeasonId']),
    ...mapGetters(['gameById', 'isPremium'])
  },
  created: function () {
    if (this.activeSeasonId === -1) {
      this.bypass = true
      if (!this.$route.path.toLowerCase().startsWith('/season/settings')) {
        this.$router.push('/season/settings')
      }
    }
  },
  methods: {
    addGame: function () {
      this.gameInfoTemp = {}
      this.gameInfoTemp.id = -1
      this.gameInfoTemp.d = DateTime.local().startOf('day').toISODate()
      this.gameInfoTemp.b = ''
      this.broadcast = false
      this.isNew = true
      this.gameInfoTemp.players = []
      this.gameInfoTemp.inGamePlayers = []
      this.gameInfoTemp.availablePlayers = JSON.parse(JSON.stringify(this.seasonPlayers))
      if (this.seasonSchedules.length > 0) {
        this.gameInfoTemp.s = this.seasonSchedules[0].id
      } else {
        this.gameInfoTemp.s = ''
      }
      this.showGameInfoDialog = true
    },
    playerAvailableClick: function (player, index) {
      this.showGameInfoDialog = false
      this.gameInfoTemp.availablePlayers.splice(index, 1)
      this.gameInfoTemp.inGamePlayers.push(player)
      this.playerSort(this.gameInfoTemp.inGamePlayers)
      this.showGameInfoDialog = true
    },
    playerInGameClick: function (player, index) {
      this.showGameInfoDialog = false
      this.gameInfoTemp.inGamePlayers.splice(index, 1)
      this.gameInfoTemp.availablePlayers.push(player)
      this.playerSort(this.gameInfoTemp.availablePlayers)
      this.showGameInfoDialog = true
    },
    updateGameInfo: function () {
      this.gameInfoTemp.inGamePlayers.forEach(player => {
        this.gameInfoTemp.players.push(player.id)
      })
      delete this.gameInfoTemp.inGamePlayers
      delete this.gameInfoTemp.availablePlayers
      if (!this.gameInfoTemp.d) {
        this.gameInfoTemp.d = DateTime.local().startOf('day').toISODate()
      }
      this.gameInfoTemp.newBroadcast = false
      this.gameInfoTemp.removeBroadcast = false
      if (this.broadcast) {
        if (this.gameInfoTemp.b === '') {
          this.gameInfoTemp.newBroadcast = true
        }
      } else {
        if (this.gameInfoTemp.b !== '') {
          this.gameInfoTemp.removeBroadcast = true
        }
      }
      this.$store.dispatch('seasonGameUpdate', { seasonId: this.activeSeasonId, game: this.gameInfoTemp })
      this.showGameInfoDialog = false
    },
    deleteGame: function () {
      if (this.gameInfoTemp.id !== -1) {
        this.$store.dispatch('seasonGameDelete', {gameId: this.gameInfoTemp.id})
      }
      this.showGameInfoDialog = false
    },
    showGameInfo: function (game) {
      this.gameInfoTemp = JSON.parse(JSON.stringify(game))
      if (!this.gameInfoTemp.d) {
        this.gameInfoTemp.d = DateTime.local().startOf('day').toISODate()
      }
      this.gameInfoTemp.inGamePlayers = []
      this.gameInfoTemp.availablePlayers = []
      this.seasonPlayers.forEach(player => {
        if (!this.idExists(this.gameInfoTemp.players, player.id)) {
          this.gameInfoTemp.availablePlayers.push(player)
        } else {
          this.gameInfoTemp.inGamePlayers.push(player)
        }
      })
      this.gameInfoTemp.players = []
      this.broadcast = this.gameInfoTemp.hasOwnProperty('b') && this.gameInfoTemp.b !== ''
      this.isNew = false
      this.showGameInfoDialog = true
    },
    playerSort: function (players) {
      players.sort(function (a, b) {
        var nameA = a.n.toUpperCase()
        var nameB = b.n.toUpperCase()

        if (nameA < nameB) {
          return -1
        }

        if (nameA > nameB) {
          return 1
        }

        return 0
      })
      return players
    },
    idExists: function (arr, id) {
      return arr.some(function (el) {
        return el === id
      })
    },
    addAllPlayers: function () {
      this.showGameInfoDialog = false
      this.gameInfoTemp.availablePlayers.forEach(player => {
        this.gameInfoTemp.inGamePlayers.push(player)
      })
      this.gameInfoTemp.availablePlayers = []
      this.playerSort(this.gameInfoTemp.inGamePlayers)
      this.showGameInfoDialog = true
    },
    removeAllPlayers: function () {
      this.showGameInfoDialog = false
      this.gameInfoTemp.inGamePlayers.forEach(player => {
        this.gameInfoTemp.availablePlayers.push(player)
      })
      this.gameInfoTemp.inGamePlayers = []
      this.playerSort(this.gameInfoTemp.availablePlayers)
      this.showGameInfoDialog = true
    }
  }
}
</script>

<style lang="scss">
 .md-switch {
    display: flex;
  }
.cardGame {
   width: 250px;
  }
  .gameInfoInputDialog i {
    color: #ff9800 !important;
  }
  .gameInfoInputDialog svg {
    fill: #ff9800 !important;
  }
  .seasonGamesButtonColumn {
    display : flex;
    align-items : center;
  }
</style>
